import { apolloService } from 'app/services';
import { COURSE_LAUNCH_TRACKING_MUTATION } from 'app/gql';
import { Environment } from '../../../utils';

export const sendCourseTracking = async ( environment, token, courseName ) => {
    // Determine if the data provided is valid and can be sent for tracking. At the
    // moment, the environment is the only piece of data that is essential.
    const validData = [ Environment.QA, Environment.PPRD, Environment.PROD ].includes( environment );

    if ( validData ) {
        // console.log( `Data for course '${ courseName }' has been sent for tracking...`, { environment, token, courseName } );
        return await apolloService.mutate( { variables: { token, courseName, environment }, fetchPolicy: 'no-cache', mutation: COURSE_LAUNCH_TRACKING_MUTATION } );
    } else {
        console.warn( `Tracking for course '${ courseName }' has failed.`, { environment, token, courseName } );
        return undefined;
    }
};
